import type { SVGProps } from "react";

export function WhitePlus(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.75 5.25C10.75 4.83579 10.4142 4.5 10 4.5C9.58579 4.5 9.25 4.83579 9.25 5.25V9.75H4.75C4.33579 9.75 4 10.0858 4 10.5C4 10.9142 4.33579 11.25 4.75 11.25L9.25 11.25V15.75C9.25 16.1642 9.58579 16.5 10 16.5C10.4142 16.5 10.75 16.1642 10.75 15.75V11.25L15.25 11.25C15.6642 11.25 16 10.9142 16 10.5C16 10.0858 15.6642 9.75 15.25 9.75H10.75V5.25Z"
        fill="white"
      />
    </svg>
  );
}
